<label *ngIf="movementMean">
  <img [src]="movementMean.imageUrl">
  {{ movementMean.name }}
</label>
